import React, { useMemo } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
import { ExclamationCircleOutlined } from '@ant-design/icons';

function FBSectionErroMessage({ 
  showMessage,
  message,
  // default props
  className
}) {
  const childClassNames = classNames('tcf-fb-group-error', className);

  const renderMsg = useMemo(() => (
    <>
      <ExclamationCircleOutlined className="tcf-fb-group-error__icon" />
      <span className="tcf-fb-group-error__message">
        {message}
      </span>
    </>
  ), [message, showMessage]);

  return showMessage && (
    <div className={childClassNames}>
      {renderMsg}
    </div>
  );
}

FBSectionErroMessage.defaultProps = {
  showMessage: false,
  message: `Vérifiez si le formulaire est correctement rempli`,
};

export default FBSectionErroMessage;